import { CamposGenericos } from "./camposGenericos";
import { PedidoAbastecimientoCabecera } from "./pedidoAbastecimientoCabecera";


export class PedidoAbastecimientoItem extends CamposGenericos {
    fechaAprobacion: Date;
    descuentoCategoria: number;
    precioKGL: number;
    precioUnitarioFinal: number;
    precioUnitarioLista: number;
    total: number;
    totalLocal: number;
    cantidad: number;
    nroLinea: number;
    nroPedido: number;
    aprobador: string;
    estado: string;
    idCompania: string;
    idDivision: string;
    idEstado: string;
    idPais: string;
    idPlanta: string;
    planta: string;
    idProducto: string;
    producto: string;
    idSalesOrg: string;
    idTipoOrden: string;
    idUbicacionAlmacenamiento: string;
    tipoOrden: string;
    usuarioRedAprobador: string;
    idLote: string;
    idMoneda: string;
    unidadesPallet: number;
    cantidadRecibida: number;

    public constructor(init?: Partial<PedidoAbastecimientoCabecera>) {
        super();
        Object.assign(this, init);
    }
}